// react
/* eslint-disable */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
// react
import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl, ViewImg } from "../services/service";

// third-party
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";

import Currency from "../shared/Currency";
// data stubs
import theme from "../../data/theme";
import "./Main.css";

export default function AccountPageOrderDetails() {
    const [CardData, setCardData] = useState([]);
    const [CardView, setCardView] = useState(false);
    const [FeedbackView, setFeedbackView] = useState(false);
    const UserEmail = localStorage.getItem("UserEmail");
    const UserID = localStorage.getItem("UserID");

    const location = useLocation();
    const orderDetails = location.state?.orderDetails;

    const getMonthName = (monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString("en-US", { month: "long" });
    };

    const SplitDate = (OrderDate) => {
        const MainDate = OrderDate.split("T");
        const SplitT = MainDate[0];
        const OrderDates = SplitT.split("-");
        const FinalDate = OrderDates[2] + " " + getMonthName(OrderDates[1]) + ", " + OrderDates[0];
        return FinalDate;
    };

    const GetAddress = async () => {
        await axios.get(MyApiUrl + "OrderItems/" + orderDetails.orders_pkid + "").then((response) => {
            console.log(response);
            if (response.data.length > 0) {
                setCardData(response.data);
                console.log(response.data);
                setCardView(true);
            } else {
                setCardData([]);
            }
        });
    };
    const GetFeedback = async () => {
        await axios
            .get(MyApiUrl + "GetProductsForReviews/" + orderDetails.orders_pkid + "/" + UserID + "")
            .then((response) => {
                console.log(response);
                if (response.data.length > 0) {
                    setFeedbackView(true);
                }
            });
    };
    React.useEffect(() => {
        GetAddress();
        GetFeedback();
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Order Details — ${theme.name}`}</title>
            </Helmet>
            {CardView && (
                <div className="order-page">
                    {/* ===== ORDER HEADER ===== */}
                    <div className="order-header-card">
                        <Link to="/account/orders" className="back-link">
                            ← Back to Orders
                        </Link>

                        <div className="order-header-main">
                            <h3>
                                Order <span>{orderDetails.orders_number}</span>
                            </h3>
                            <p>
                                Placed on <strong>{SplitDate(orderDetails.orders_date)}</strong>
                            </p>

                            <span className="status-pill">{orderDetails.orders_status}</span>
                        </div>
                    </div>

                    {/* ===== ORDER ITEMS ===== */}
                    <div className="order-card">
                        <h4 className="section-title">Items</h4>

                        {CardData[0].orders_items.map((item) => (
                            <div key={item.order_item_pkid} className="order-item-row">
                                <div className="item-info">
                                    <div className="item-name">{item.product_name} ({item.product_unit_weight})</div>
                                    <div className="item-meta">
                                        {item.product_unit_selling_price} × {item.order_item_quantity}
                                    </div>
                                </div>

                                <div className="item-price">
                                    <Currency value={item.order_item_amount} />
                                </div>
                            </div>
                        ))}

                        <div className="price-summary">
                            <div>
                                <span>Subtotal</span>
                                <Currency value={CardData[0].orders_sub_total} />
                            </div>
                            <div>
                                <span>Shipping</span>
                                <Currency value={CardData[0].orders_shipping_amount} />
                            </div>
                            <div>
                                <span>Total</span>
                                <Currency value={CardData[0].orders_total_amount} />
                            </div>
                            <div>
                                <span>Coupon Discount</span>
                                <Currency value={CardData[0].orders_coupon_discount} />
                            </div>
                            <div className="grand">
                                <span>Grand Total</span>
                                <Currency value={CardData[0].orders_grand_total} />
                            </div>
                        </div>
                    </div>

                    {/* ===== ADDRESS & COUPON ===== */}
                    <div className="order-grid">
                        <div className="order-card">
                            <h4 className="section-title">Shipping Address</h4>

                            {CardData[0].orders_address.map((addr) => (
                                <div key={addr.user_address_phone}>
                                    <strong>{addr.user_address_name}</strong>
                                    <p className="address-text">
                                        {addr.user_address_house_no}, {addr.user_address_street}
                                        <br />
                                        {addr.area_name}, {addr.city_name}, {addr.state_name}
                                        <br />
                                        {addr.country_name} - {addr.user_address_zipcode}
                                    </p>
                                    <p className="muted">📞 {addr.user_address_phone}</p>
                                </div>
                            ))}
                        </div>

                        <div className="order-card">
                            <h4 className="section-title">Coupon</h4>

                            {CardData[0].orders_coupons.length > 0 ? (
                                CardData[0].orders_coupons.map((c) => (
                                    <div key={c.coupon_code} className="coupon-box">
                                        <div>
                                            <b>Type:</b> {c.member_coupon_type}
                                        </div>
                                        <div>
                                            <b>Code:</b> {c.coupon_code}
                                        </div>
                                        <div>
                                            <b>Discount:</b> {c.coupon_discount}%
                                        </div>
                                        <div>
                                            <b>Reference:</b> {c.member_name}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="muted">No coupon applied</p>
                            )}
                        </div>
                    </div>

                    {/* ===== FEEDBACK ===== */}
                    {FeedbackView && (
                        <div className="feedback-bar">
                            <Link
                                to={{
                                    pathname: "/account/giveFeedback",
                                    state: { orderDetails },
                                }}
                                className="btn btn-warning"
                            >
                                Give Feedback & Review
                            </Link>
                        </div>
                    )}
                </div>
            )}
        </React.Fragment>
    );
}
